/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { OrderHistoryDtoGenericResponse } from '../models/order-history-dto-generic-response';

@Injectable({ providedIn: 'root' })
export class OrderInfoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1OrdersInfoOrderIdGet()` */
  static readonly ApiV1OrdersInfoOrderIdGetPath = '/api/v1/orders/info/{orderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1OrdersInfoOrderIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1OrdersInfoOrderIdGet$Plain$Response(
    params: {
      orderId: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, OrderInfoService.ApiV1OrdersInfoOrderIdGetPath, 'get');
    if (params) {
      rb.path('orderId', params.orderId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1OrdersInfoOrderIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1OrdersInfoOrderIdGet$Plain(
    params: {
      orderId: string;
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1OrdersInfoOrderIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1OrdersInfoOrderIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1OrdersInfoOrderIdGet$Json$Response(
    params: {
      orderId: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<OrderHistoryDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, OrderInfoService.ApiV1OrdersInfoOrderIdGetPath, 'get');
    if (params) {
      rb.path('orderId', params.orderId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderHistoryDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1OrdersInfoOrderIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1OrdersInfoOrderIdGet$Json(
    params: {
      orderId: string;
    },
    context?: HttpContext
  ): Observable<OrderHistoryDtoGenericResponse> {
    return this.apiV1OrdersInfoOrderIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderHistoryDtoGenericResponse>): OrderHistoryDtoGenericResponse => r.body)
    );
  }

}
